<template>
    <div class="animated fadeIn item-page">
        <component-new-header
            title="Items"
            @search-query="(val) => (filter = val)"
            :isLoading="isloader"
            @reload-data="refreshAllDataItem"
            :hasCreate="false"
        />
        <b-row>
            <b-col cols="12" md="12">
                <b-card class="min-height-450">
                    <b-row>
                        <b-col cols="12" sm="6" md="2" class="my-1">
                            <b-form-group label-cols-sm="3" class="mb-0">
                                <b-form-select
                                    :options="pageOptions"
                                    id="pagination"
                                    v-model="perPage"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            sm="6"
                            md="3"
                            class="my-1"
                            v-if="
                                $userRole === 'Partner' &&
                                segmentType === 'MARKET'
                            "
                        >
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedMarketId"
                                    :options="marketList"
                                    label="text"
                                    :id="'selectMarket'"
                                    placeholder="Select Market"
                                    @input="onChangeMarket"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            sm="6"
                            md="3"
                            class="my-1"
                            v-if="$userRole === 'Partner'"
                        >
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedMarketCategoryId"
                                    :options="marketCategory"
                                    label="text"
                                    :id="'selectcategory'"
                                    placeholder="Select Category"
                                    @input="onChangeCategory"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="3" class="my-1">
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedCatalogId"
                                    v-model="selectedCatalogId"
                                    :options="catalogList"
                                    label="text"
                                    :id="'selectCatalog'"
                                    placeholder="Select Product Catalog"
                                    @input="catalogNameChange"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            sm="12"
                            md="3"
                            class="my-1"
                            v-if="
                                selectedCatalogId.value.length &&
                                userPermission.hasOwnProperty('CREATE_ITEM')
                            "
                        >
                            <router-link
                                :to="`item/create/${selectedCatalogId.value}`"
                            >
                                <button
                                    class="mr-1 btn btn-primary"
                                    variant="facebook"
                                    id="createItem"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span class="ml-1"><b>Create</b></span>
                                </button>
                            </router-link>
                            <router-link
                                :to="`item/bulk/create/${selectedCatalogId.value}`"
                            >
                                <button
                                    v-if="this.$userRole === 'Partner'"
                                    class="mr-1 btn btn-primary"
                                    variant="facebook"
                                    id="createItem"
                                >
                                    <i class="fas fa-mail-bulk"></i>
                                    <span class="ml-1"><b>Bulk Create</b></span>
                                </button>
                            </router-link>
                        </b-col>
                    </b-row>
                    <b-table
                        id="table-transition-example"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="itemTableData"
                        :fields="itemTableField"
                        :current-page="currentPage"
                        v-if="!loading"
                        :per-page="perPage"
                        :filter="filter"
                        class="mt-2 tableRadius professional-stacked-table"
                        stacked="md"
                        thead-class="header"
                        primary-key="_id"
                        show-empty
                        :tbody-transition-props="transProps"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="action-cell">
                                <ActionButtonGroup
                                    :showView="
                                        userPermission.hasOwnProperty(
                                            'VIEW_ITEM',
                                        )
                                    "
                                    :showEdit="
                                        userPermission.hasOwnProperty(
                                            'UPDATE_ITEM',
                                        )
                                    "
                                    :showDelete="
                                        userPermission.hasOwnProperty(
                                            'DELETE_ITEM',
                                        )
                                    "
                                    @view="navigateToView(data, 'ViewItem')"
                                    @edit="navigateToView(data, 'EditItem')"
                                    @delete="deleteItem(data)"
                                />
                                <div class="action-extras">
                                    <b-button
                                        v-if="userRole === 'Tenant'"
                                        size="sm"
                                        id="copyItem"
                                        class="mr-2"
                                        variant="primary"
                                        @click="navigateToView(data, 'CopyItem')"
                                    >
                                        <i class="fa fa-copy"></i> Copy Item
                                    </b-button>
                                    <b-button
                                        v-if="!data.item.isOffline"
                                        size="sm"
                                        id="viewWeb"
                                        class="mr-2"
                                        variant="primary"
                                        @click="viewOnWeb(data.item._id)"
                                    >
                                        <i class="fa fa-podcast"></i> Live
                                        Product
                                    </b-button>
                                    <div class="online-toggle">
                                        <p class="m-0 p-0 mr-1 font-size-15">
                                            {{
                                                data.item.isOffline
                                                    ? "Offline"
                                                    : "Online"
                                            }}
                                        </p>
                                        <c-switch
                                            @change="
                                                (e) =>
                                                    offlineItem(
                                                        data.item,
                                                        data.index,
                                                    )
                                            "
                                            :value="data.item.isOffline"
                                            color="primary"
                                            class="mx-2"
                                            variant="pill"
                                        >
                                        </c-switch>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </b-table>
                    <b-row
                        v-if="
                            selectedCatalogId.value.length &&
                            items.length > perPage &&
                            !loading
                        "
                    >
                        <b-col md="12">
                            <nav class="float-right">
                                <b-pagination
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    v-model="currentPage"
                                    prev-text="Prev"
                                    next-text="Next"
                                    hide-goto-end-buttons
                                />
                            </nav>
                        </b-col>
                    </b-row>
                    <b-row v-if="loading">
                        <b-col md="6">
                            <atom-spinner
                                :animation-duration="1000"
                                :size="60"
                                color="#ff1d5e"
                                class="float-right my-4"
                            />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cTable from "@/views/base/Table.vue";
import { mapState, mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentNewHeader from "@/components/componentNewHeader";
import { tenantWebsites } from "@/shared/tenantWebsites.config";
import { Switch as cSwitch } from "@/components/Switch";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "ViewItem",
    components: {
        cTable,
        AtomSpinner,
        ebSelect,
        loader,
        ComponentNewHeader,
        cSwitch,
        tenantWebsites,
        ActionButtonGroup,
    },
    data: () => {
        return {
            mymodalclass: ["mymodalclass"],
            transProps: {
                name: "flip-list",
            },
            showDismissibleAlert: false,
            loading: false,
            isloader: false,
            items: [],
            provider: "",
            fields: [],
            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            valuesMap: {},
            isAddresscapture: false,
            itemObj: {},
            perPage: 5,
            pageOptions: [5, 10, 15, 20, 25, 30],
            currentPage: 1,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
        };
    },
    methods: {
        navigateToView(data, routeName) {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: `Partner${routeName}`,
                    params: {
                        id: this.partnerAllData._id,
                        itemId: data.item._id,
                    },
                });
            } else {
                this.$router.push({
                    name: routeName,
                    params: { id: data.item._id },
                });
            }
        },
        async offlineItem(item, index) {
            const payload = {
                data: {
                    isOffline: !item.isOffline,
                    itemIds: [item._id],
                },
            };
            const itemIndex = this.perPage * (this.currentPage - 1) + index;
            const oldStatus = item.isOffline;
            this.$set(this.items, itemIndex, {
                ...item,
                isOffline: payload.data.isOffline,
            });

            try {
                await this.$store.dispatch("item/offlineItem", payload);
            } catch (err) {
                // if failed revert it
                this.$set(this.items, itemIndex, {
                    ...item,
                    isOffline: oldStatus,
                });
            }
            await this.refreshAllDataItem();
        },
        async viewOnWeb(productId) {
            const productURL = `${
                tenantWebsites[this.userTenantId].URL
            }/${productId}`;
            window.open(productURL, "_blank");
        },
        async onChangeMarket(data) {
            let searchString = `parent=${data.value}`;
            this.$store.dispatch("item/changeMarketId", data);
            try {
                await this.$store.dispatch(
                    "item/fetchCatalogList",
                    searchString,
                );
            } catch (error) {
                this.$toasted.error(error.message);
            }
        },
        async onChangeCategory(data) {
            let searchString = `parent=${data.value}`;
            this.$store.dispatch("item/changeMarketCategory", data);
            try {
                await this.$store.dispatch(
                    "item/fetchCatalogListByMarketCategory",
                    searchString,
                );
            } catch (error) {
                this.$toasted.error(error.message);
            }
        },
        async catalogNameChange(data) {
            this.$store.dispatch("item/changeCatelogId", data);
            if (data) {
                this.loading = true;
                const { VIEW_ALL_ITEMS } = this.permissions;
                let condition = {
                    provider: this.provider,
                    catalogId: data.value,
                };
                if (this.userRole === "Tenant") {
                    delete condition.provider;
                }
                await this.$store.dispatch(
                    "item/fetchItemsByCatalog",
                    condition,
                );
                let result = this.$store.getters["item/GetItemListByCatalog"];
                result = Array.isArray(result)
                    ? result.filter((item) => !item.isDeleted)
                    : [];
                if (result.length > 0) {
                    this.items = result.map((e) => {
                        const { integer_attributes } = e;
                        const { string_attributes } = e;
                        if (integer_attributes) {
                            integer_attributes.filter((eb, idex) =>
                                eb.attribute_name === "Price"
                                    ? (e.Price = eb.attribute_value)
                                    : eb.attribute_name === "Stock"
                                      ? (e.stock = eb.attribute_value)
                                      : "",
                            );
                        }
                        if (string_attributes) {
                            string_attributes.filter((eb, idex) =>
                                eb.attribute_name === "Brand"
                                    ? (e.Brand = eb.attribute_value)
                                    : "",
                            );
                        }
                        return e;
                    });
                    this.setDefaultColumnsValue();

                    if (this.items.length === 0)
                        this.showDismissibleAlert = true;
                    else this.showDismissibleAlert = false;

                    this.fields = [];
                    this.fields.push(
                        {
                            key: "Name",
                            label: "Name",
                            sortable: true,
                        },
                        {
                            key: "Price",
                            label: "Price",
                        },
                        {
                            key: "Type",
                            label: "Type",
                        },
                        {
                            key: "productType",
                            label: "Product Type",
                        },

                        {
                            key: "Inventory",
                            label: "Inventory",
                        },
                        {
                            key: "IsSellable",
                            label: "Is Sellable",
                        },
                    );

                    result[0]["Brand"]
                        ? this.fields.push({
                              key: "Brand",
                              label: "Brand",
                              class: "text-center",
                          })
                        : null;

                    result.map((Obj) => {
                        Obj.Name = Obj.string_attributes[0].attribute_value;
                    });
                    for (let key in result[0]) {
                        if (
                            typeof result[0][key] !== "object" &&
                            this.fields.length < 6 &&
                            key != "string_attributes[0].attribute_value" &&
                            key != "_id" &&
                            key != "tenant" &&
                            key != "provider" &&
                            key != "catalogId" &&
                            key != "createdAt" &&
                            key != "isDeleted" &&
                            key != "updatedAt" &&
                            key != "Lat" &&
                            key != "Lng" &&
                            key != "Country" &&
                            key != "State" &&
                            key != "City" &&
                            key != "Area" &&
                            key != "productType" &&
                            key != "Type" &&
                            key != "Inventory" &&
                            key != "IsSellable" &&
                            key != "AvgRating" &&
                            key != "manufacturerId"
                        ) {
                            this.fields.push({
                                key: key,
                                label: key,
                            });
                        }
                    }
                    this.loading = false;
                    this.fields.push({
                        key: "action",
                        label: "Action",
                        class: "text-center action-column",
                    });
                } else {
                    this.loading = false;
                    this.items = [];
                }
            } else {
                this.items = [];
                this.loading = false;
            }
            this.$store.dispatch("item/storeItemTableData", {
                items: this.items,
                fields: this.fields,
            });
        },

        setDefaultColumnsValue() {
            this.items.map((obj) => {
                if (!obj["Type"]) {
                    obj["Type"] = "PRODUCT";
                }
                if (!obj["productType"]) {
                    obj["productType"] = "NORMAL";
                }
                if (!["TRUE", "FALSE"].includes(obj["IsSellable"])) {
                    obj["IsSellable"] = "TRUE";
                }

                if (!obj["Inventory"]) {
                    obj["Inventory"] = "FALSE";
                } else {
                    obj["Inventory"] === "1"
                        ? (obj["Inventory"] = "TRUE")
                        : (obj["Inventory"] = "FALSE");
                }
            });
        },

        async deleteItem(rowdata) {
            await this.$store.dispatch("item/fetchItemById", rowdata.item._id);
            let data = this.$store.getters["item/GetCurrentItemObject"];
            const responsePayload = data && data.response;
            let result =
                responsePayload && Array.isArray(responsePayload)
                    ? responsePayload[0] || null
                    : responsePayload && typeof responsePayload === "object"
                      ? responsePayload
                      : null;
            if (!result) {
                this.$toasted.error("Unable to load item details");
                return;
            }
            this.itemObj = result;
            this.isAddresscapture = false;
            let typeSet = new Set(["String", "Number", "Object", "Array"]);
            let attributesMap = new Map([
                ["String", []],
                ["Number", []],
                ["Object", []],
                ["Array", []],
            ]);
            let valuesMap = result;
            const attributeItems = Array.isArray(result.attributeItems)
                ? result.attributeItems
                : [];
            attributeItems.forEach((item) => {
                if (item) {
                    if (item.attributeName === "Address") {
                        this.isAddresscapture = true;
                    }
                    let type = item.attributeValueType,
                        name = item.attributeName;
                    // check key value is allowed type
                    if (typeSet.has(type)) {
                        let attObj = {
                            ...item,
                            type,
                            name,
                        };
                        attributesMap.set(
                            type,
                            attributesMap.get(type).concat([attObj]),
                        );
                        if (type == "Array") {
                            if (attObj.UIConcern === "Select") {
                                const attributeOptions = Array.isArray(
                                    attObj.attributeItems,
                                )
                                    ? attObj.attributeItems
                                    : [];
                                let options = new Map(
                                    attributeOptions
                                        .filter((a) => a && (a._id || a.id))
                                        .map((a) => {
                                            const optionId = a._id || a.id;
                                            return [
                                                optionId,
                                                {
                                                    label: a.attributeName,
                                                    value: optionId,
                                                },
                                            ];
                                        }),
                                );
                                const existingSelection = Array.isArray(
                                    valuesMap[name],
                                )
                                    ? valuesMap[name]
                                    : [];
                                valuesMap[name] = existingSelection
                                    .map((o) => options.get(o))
                                    .filter(Boolean);
                            }
                            if (attObj.UIConcern === "Object") {
                                valuesMap[name] = valuesMap[name];
                            }
                            if (attObj.UIConcern === "Checkbox") {
                                valuesMap[name] = valuesMap[name];
                            }
                        }
                        if (["Number", "String"].includes(type)) {
                            const addresses = {
                                Number: "integer_attributes",
                                String: "string_attributes",
                            };
                            const attributes = Array.isArray(
                                result[addresses[type]],
                            )
                                ? result[addresses[type]]
                                : [];
                            const valueItem = attributes.find(
                                (pair) => pair.attribute_name == name,
                            );
                            if (valueItem) {
                                valuesMap[name] = valueItem.attribute_value;
                            }
                        }
                    }
                }
            });
            this.attributesMap = attributesMap;
            this.valuesMap = valuesMap;

            let payload = {
                ...this.valuesMap,
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                },
            };
            // Casting select fields
            Object.keys(this.valuesMap || {}).forEach((key) => {
                let tempItem = (this.valuesMap || {})[key];
                if (
                    Array.isArray(tempItem) &&
                    tempItem.length > 0 &&
                    tempItem[0] &&
                    tempItem[0].value
                ) {
                    payload[key] = tempItem.map((v) => v.value);
                }
            });

            if (
                Array.isArray(payload.string_attributes) &&
                payload.string_attributes[0]
            ) {
                payload.string_attributes[0].attribute_value = payload.Name;
            }
            payload.catalogId = this.itemObj.catalogId || this.itemObj.catalogid;
            delete payload.product_summary;
            delete payload.updatedAt;
            delete payload.createdAt;
            delete payload._id;
            delete payload.Title;
            delete payload.attributeItems;
            delete payload.string_attributes;
            delete payload.integer_attributes;
            delete payload.tags;
            payload.isDeleted = true;
            if (payload["Name"] === "") {
                payload["Name"] = this.itemObj.Name;
                payload["string_attributes[0].attribute_value"] =
                    payload["Name"];
            }

            const productSummary =
                (this.itemObj && this.itemObj.product_summary) || {};
            const productImages = productSummary.images || {};
            payload.images.icon = productImages.icon || "";
            payload.images.smallImage = productImages.smallImage || "";
            payload.images.bigImage = productImages.bigImage || "";

            // check for address Object if exist //////
            if (this.isAddresscapture) {
                const currentAddress = this.itemObj.Address || {};
                payload.City = currentAddress.City;
                payload.Country = currentAddress.Country;
                payload.State = currentAddress.State;
                payload.Lat = currentAddress.Lat;
                payload.Lng = currentAddress.Lng;
                payload.Address = {
                    Lng: payload.Lng,
                    Lat: payload.Lat,
                    City: payload.City,
                    State: payload.State,
                    Country: payload.Country,
                    Address: currentAddress.Address,
                };
                payload.Area = payload.Address.Address;
            }
            // dataObj for API
            let dataObj = { id: rowdata.item._id, object: payload };
            const swalResult = await this.$swal({
                title: "Delete this Item?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("item/updateItemById", dataObj)
                        .then((result) => {
                            this.$toasted.success("Item Deleted");
                            this.refreshAllDataItem();
                            this.items = this.items.filter(
                                (obj) => obj._id !== rowdata.item._id,
                            );
                        })
                        .catch((err) => {
                            this.$toasted.error("Item not deleted");
                        });
                }
            });
        },

        async refreshAllDataItem() {
            this.isloader = true;
            try {
                this.provider = this.$store.getters["auth/getUserID"];
                if (this.userRole === "Tenant") {
                    await this.$store.dispatch("item/loadTenantCatelogTree");
                } else {
                    this.catalogNameChange(this.selectedCatalogId);
                }
            } catch (error) {
                this.$toasted.error(error.message);
            } finally {
                this.isloader = false;
            }
        },
    },
    mounted: async function () {
        if (this.partnerAllData == null && this.$route.params.id) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        this.isloader = true;
        try {
            this.provider = this.$store.getters["auth/getUserID"];
            if (this.userRole === "Tenant") {
                let tenCatelogTree =
                    this.$store.getters["catalog/GetTenantCatalogTree"].length;
                if (!tenCatelogTree.length) {
                    await this.$store.dispatch("item/loadTenantCatelogTree");
                }
            } else {
                if (!this.marketList.length) {
                    await this.$store.dispatch("item/loadPartnerMarketSegment");
                }
            }
        } catch (error) {
            this.$toasted.error(error.message);
        } finally {
            await this.refreshAllDataItem();
            this.isloader = false;
        }
    },
    computed: {
        ...mapState("auth", ["permissions"]),
        ...mapState({
            marketList: (state) => state.item.marketList,
            segmentType: (state) => state.item.segmentType,
            marketCategory: (state) => state.item.marketCategory,
            catalogList: (state) => state.item.catalogList,
            selectedMarketId: (state) => state.item.selectedMarketId,
            selectedMarketCategoryId: (state) =>
                state.item.selectedMarketCategoryId,
            selectedCatalogId: (state) => state.item.selectedCatalogId,
            itemTableField: (state) => state.item.itemTableField,
            itemTableData: (state) => state.item.itemTableData,
        }),
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        userTenantId() {
            if (this.userRole === "Tenant") {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
            return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
        },
        totalRows() {
            return this.items.length;
        },
        userPermission() {
            return this.$store.getters["auth/getUserPermissions"];
        },
    },
};
</script>

<style scoped>
.mymodalclass > div {
    margin-top: 45px !important;
}
.text-center {
    text-align: center !important;
}
[data-font="20"] {
    font-size: 20px;
}
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}

.min-height-450 {
    min-height: 450px;
}

.font-size-15 {
    font-size: 15px;
}

.action-cell {
    min-width: 330px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.action-cell :deep(.action-btn-group) {
    display: flex !important;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
}

.action-extras {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.online-toggle {
    display: inline-flex;
    align-items: center;
    margin-left: 2px;
}

.btn-warning {
    background: #fe7b08;
    border: #fe7b08;
}

.btn-warning:hover {
    background: #e66a00;
    border-color: #e66a00;
}
</style>
<style>
.item-page table.table-bordered > tbody > tr {
    /* text-transform: capitalize; */
    text-align: center;
}

.item-page table#table-transition-example th.action-column,
.item-page table#table-transition-example td.action-column {
    min-width: 360px;
    white-space: normal;
    vertical-align: middle;
}

.item-page table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
</style>
